import { render, staticRenderFns } from "./BoRecipeCat.vue?vue&type=template&id=44ce7398&"
import script from "./BoRecipeCat.vue?vue&type=script&lang=js&"
export * from "./BoRecipeCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports